var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.className,style:(_vm.imgStyle),attrs:{"src":_vm.src,"alt":_vm.alt,"title":_vm.title,"width":_vm.width,"height":_vm.height,"loading":"lazy"},on:{"error":_vm.handleError}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb981a60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResponsiveImage.vue
// module id = null
// module chunks = 